import styled from 'styled-components';
import { textMixin } from '@styles/mixins';

export const StyledSpan = styled.span`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 600,
    })};
`;
export const StyledLabel = styled.p`
    ${textMixin({
        fontSize: '13px',
        fontWeight: 400,
    })};
`;
